<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text class="justify-center">
          <v-container>
            <v-layout wrap>
              <span>{{ title }}</span>
              <v-btn :disabled="working.wUpdate" flat @click="this.close()">Cancelar</v-btn>
              <v-btn color="primary darken-1" flat>Guardar</v-btn>
            </v-layout>
            <v-layout>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";


export default {
  props: ["title", "employee", "description", "roles"],
  components: {
    loading,
    success,
    error
  },
  watch: {
 
  },
  mounted() {},
  data: () => ({
    modals: {
      image: false
    },
    toast: {
      success: false,
      failed: false,
      eMessage: ""
    },
  }),
  methods: {
   
  },
  computed: {
   
  }
};
</script>

<style>
</style>
